jQuery(document).on('page.ready', function() { $ = jQuery;

  ParallaxScroll.init();

});